import { TemplateRef } from '@angular/core';
import { IconName } from '@fortawesome/fontawesome-svg-core';

export interface DataTableColDef {
  headerName: string;
  field?: string;
  /* function should return a string or number with the value to display */
  valueGetter?: Function;
  /* function should return an IconName */
  icon?: IconName | Function;
  /*
    Function should return a string
    Returned string should be an Ionic color string
  */
  color?: string | Function;

  /* use this prop when sortable === true and valueGetter is used to display info */
  sortField?: string;

  /* use this prop when sortable === true and e.g. sorted value is a string, but should be sorted as number */
  sortFunction?: Function

  template?: TemplateRef<any>;
  headerTemplate?: TemplateRef<any>;
  sortable?: boolean;
  size?: number;
  align?: 'start' | 'center' | 'end';
  cssClass?: string; // Custom CSS class for the column
}
